var map_styling = [
    {
        featureType: "poi",
        elementType: "labels",
                stylers: [{
                    visibility: "off"
                }]
            }, 
            { 
                featureType: "road.local", 
                elementType: "labels.icon", 
                stylers: [{ 
                    "visibility": "off" 
                }] 
            },
            { 
                featureType: "road.arterial", 
                elementType: "labels.icon", 
                stylers: [{ 
                    "visibility": "off" 
                }] 
            },
            {
                featureType: "road",
                elementType: "geometry.stroke",
                stylers: [{
                    visibility: "off"
                }]
            }, 
            {
                elementType: "geometry",
                stylers: [{
                    saturation: -100
                }]
            },
            {
                elementType: "labels",
                stylers: [{
                saturation: -100
                }]
            }, 
            {
                featureType: "poi",
                elementType: "geometry.fill",
                stylers: [{
                    color: "#ffffff"
                }]
            },
            {
                featureType: "landscape",
                stylers: [{
                    color: "#ffffff"
                }]
            }, 
            {
                featureType: "road",
                elementType: "geometry.fill",
                stylers: [ {
                    color: "#f1f1f1"
                }]
            }, 
            {
                featureType: "water",
                elementType: "geometry",
                stylers: [{
                    color: "#0066b3"
                }]
            }
];

function initContactForm() {
    $('.contact-form').validate({
        submitHandler: function() {
            var data = $('.contact-form').serialize();
            var object = {
                'success': function (response){
                    $('.contact-form .form-response').removeClass('alert-success');
                    $('.contact-form .form-response').removeClass('alert-danger');

                    if(response['status']=='ok'){
                        $('.contact-form .form-response').addClass('alert-success').show().html(response['message']);
                    }else{
                        $('.contact-form .form-response').addClass('alert-danger').show().html(response['error']);
                    }
                },
                'data' : data
            };
            $.ajax(object);
            return false;
        },
        errorPlacement: function(error, element) {
            // error.hide();
        },
        highlight: function (element, errorClass, validClass) {
            $(element).parent().find('.form-control-feedback').remove();
             $(element).closest('.form-group').append('<span class=" form-control-feedback"><i class="fa fa-exclamation-triangle"></i></span>');
             $(element).closest('.form-check').append('<span class=" form-control-feedback"><i class="fa fa-exclamation-triangle"></i></span>');
             $(element).parent().addClass('has-error has-feedback');
             $('.form-check-label').addClass('has-padding');
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).parent().find('.form-control-feedback').remove();
             $(element).parent().removeClass('has-error has-feedback');
             $(element).closest('.form-check-label').removeClass('has-padding');
        }
    });
}

var overlay;



function CustomMarker(opts) {
    this.setValues(opts);
}


function setMap(){

    if (typeof $('.map-container-contact')[0] !== "undefined") {
            
        var mapCenterlat = 38.2144744;
        var mapCenterlng = 23.8753379;
       
        var infowindow = new google.maps.InfoWindow(
        {
            pixelOffset: new google.maps.Size(0,-50)
        });

        var options = {
             zoom:13,
             scrollwheel: false,
             styles:map_styling,
             center: {lat: mapCenterlat, lng: mapCenterlng},
             fullscreenControl:false,
             streetViewControl:false,
             mapTypeControl:false,
             zoomControl:true
        };
        map = new google.maps.Map($('.map-container-contact')[0], options);
        var markers = []; 

        $('.sidebar-left  .text__content').each(function(){
                var $this = $(this);
                var markerImage = new google.maps.MarkerImage(
                        SKIN+'/img/marker.png'
                );
                var title = $this.find('.title').html();
                var latLng = new google.maps.LatLng( mapCenterlat , mapCenterlng);
                var marker = new CustomMarker({
                        position : latLng,
                        map      : map,
                        icon     : markerImage,
                        title    : title
                        
                });   

                var phone='';
                var email = '';
                
                if($this.find('.phone').length>0){
                     phone = '<div><a href="tel:'+$this.find('.phone')+'">' + $this.find('.phone').html()+ '</a></div>';
                }
                if($this.find('.mail').length>0){
                    email = '<div><a href="mailto:'+$this.find('.mail')+'">' + $this.find('.mail').html()+ '</a></div>';
                }
                var contentString =
                '<div class="maps_infobox">'+
                 '<div class="siteNotice">'+$this.find('.title').html() +'</div>'+
                 '<div class="bodyContent">'+
                    phone+email+
                     '<a target="_blank" href="'+$this.data('directions')+'">View Directions</a>'
                 '</div>'+
                '</div>';
            
                google.maps.event.addListener(marker, 'click', function(){
                     infowindow.close();
                     infowindow.setContent( contentString );
                     infowindow.open(map, marker);
                });
            });    
        }    
}


function initContactMap(){
    "use strict";   
    CustomMarker.prototype = new google.maps.OverlayView();
    CustomMarker.prototype.draw = function() {
        var self = this;
        var div = this.div;
        if (!div) {
            div = this.div = $('' +
                '<div>' +
                '<div class="shadow"></div>' +
                '<div class="pulse"></div>' +
                '<div class="pin-wrap">' +
                '<div class="pin"></div>' +
                '</div>' +
                '</div>' +
                '')[0];
            this.pinWrap = this.div.getElementsByClassName('pin-wrap');
            this.pin = this.div.getElementsByClassName('pin');
            this.pinShadow = this.div.getElementsByClassName('shadow');
            div.style.position = 'absolute';
            div.style.cursor = 'pointer';
            var panes = this.getPanes();
            panes.overlayImage.appendChild(div);
            google.maps.event.addDomListener(div, "click", function(event) {
                google.maps.event.trigger(self, "click", event);
            });
        }
        var point = this.getProjection().fromLatLngToDivPixel(this.position);
        if (point) {
            div.style.left = point.x + 'px';
            div.style.top = point.y + 'px';
        }
    };

    setMap();

    $(window).resize(function(){
        setMap();
    });
};